import { render } from "./patrol.vue?vue&type=template&id=21ed14ff&scoped=true"
import script from "./patrol.vue?vue&type=script&lang=js"
export * from "./patrol.vue?vue&type=script&lang=js"

import "./patrol.vue?vue&type=style&index=0&id=21ed14ff&scoped=true&lang=less"

import exportComponent from "G:\\B030transformer\\demo (2)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ed14ff"]])

export default __exports__